import SortPeople from "../helpers/sort-people.js";
import ExpertsPanel from "../templates/experts-panel.js";
import setChiclet from "../helpers/chiclet.js";
import modalSearch from "../helpers/modalSearch.js";

const expertsModalWidget = instantsearch.connectors.connectRefinementList(
	(
		{ widgetParams, canRefine, items, createURL, refine, helper,
		searchForItems, isFromSearch },
		isFirstRender
	) => {
		if ( ! brookingsAlgoliaFeedOptions.facets.includes('experts') ) {
			return;
		}

		const tax = widgetParams.taxonomy;
		const container = document.getElementById(`${tax}-filter-modal`);

		if (isFirstRender) {
			document.querySelector('#expertFacets').classList.add('active');

			container.addEventListener("click", ({ target }) => {
				const input = target.closest(
					'input[type="checkbox"]'
				);
				if (input) {
					refine(input.value);
				}
			});

			// container.addEventListener("input", ({ target }) => {
			// 	const isSearchInput =
			// 		target.nodeName === "INPUT" &&
			// 		target.type === "search";

			// 	if (isSearchInput) {
			// 		searchForItems(target.value);
			// 	}
			// });

			return;
		}

		modalSearch(container);

		if (!isFromSearch) {
			// container.querySelector(`#liveSearch-${tax}`).value = "";
		}

		const allExperts = JSON.parse(brookingsAlgolia.experts);

		items = items.map((item) => {
			if ( ! allExperts[Number(item.value)] ) {
				return null;
			}
			item.label = allExperts[Number(item.value)];
			return item;
		});

		items = items.filter((item) => item !== null);

		// add first and last name to each item object
		items.map((item) => {
			const name = item.label;
			if ( ! name || 'undefined' === name ) {
				return null;
			}
			item.first_name = name;
			item.last_name = '';
			if ( name ) {
				// split name into first and last name, and add to item object
				const nameWords = name.trim().split(/\s+/);
				item.first_name = nameWords[0];
				item.last_name = nameWords[nameWords.length - 1];
			}
			return item;
		});

		items = items.filter((item) => item !== null);

		const experts = SortPeople(items);

		container.querySelector("#expertFiltersContainer").innerHTML =
			experts
				.map(
					({
						firstLetter,
						people,
					}) => ExpertsPanel({
						firstLetter,
						people
					})
				)
				.join("");

		if ( ! isFirstRender ) {
			// clear .search-field
			const searchField = document.querySelector(`#${tax}-filter-modal .search-field`);
			// on .form-checkbox click, clear searchField value
			const formCheckboxes = document.querySelectorAll(`#${tax}-filter-modal .form-checkbox`);
			formCheckboxes.forEach((formCheckbox) => {
				formCheckbox.addEventListener('click', () => {
					searchField.value = '';
				});
			});
			// Expand toggles if any sub-filter is checked
			const subFilters = document.querySelectorAll('.sub-filters');
			subFilters.forEach((subFilter) => {
				const inputs = subFilter.querySelectorAll('input[type="checkbox"]');
				if (inputs.length > 0) {
					inputs.forEach((input) => {
						if (input.checked || searchField.value !== '') {
							const parentItem = input.closest('.item-parent');
							if ( parentItem ) {
								const toggle = parentItem.querySelector('.sub-filters');
								if ( toggle ) {
									toggle.removeAttribute('hidden');
								}
							}
						}
					});
				}
			});

			if ( items.length > 0 ) {
				items.forEach( (item) => {
					setChiclet(item,widgetParams.attribute,refine);
				});
			}
		}
	}
);

export default expertsModalWidget